<template>
  <section class="split-text">
    <div class="section-wrap">
      <Header dark :trigger="trigger" />
    </div>
    <div class="container container--flex">
      <h1 class="split-text__head">we desperately collected the dream team. we think that design and development goes hand in hand.</h1>
      <p class="split-text__text">Desperate. is a full service design and development agency, that helps companies with their identity and optimization of their current problems. We help our clients to improve their visual touch, the infrastructure and communication between development and design.<br><br>Either we sit on the clients location or work from the office, the best practice is that development and design sit together. Therefore it’s important to include both worlds to get the best result.<br><br><router-link :to="{ name: 'About', params: {} }" class="promo__cta">read more about us <span class="link promo__cta__btn promo__cta__btn--invert"></span></router-link></p>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'About',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/About/About.vue